import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { FETCH_GROUPS_BEGIN, logError, fetchGroupsSuccess } from "../actions";
import SocialAPIUtils from "../utils/SocialAPIUtils";
export default function fetchGroups(action$, state$) {
    return action$.pipe(ofType(FETCH_GROUPS_BEGIN), // filter(
    //   (action) =>
    //     !!state$.value.session &&
    //     !!state$.value.socialConfig &&
    //     SocialAPIUtils.getSessionToken().length > 0 &&
    //     (!state$.value.socialConfig.disclaimer.needs_endorsement ||
    //       (!!state$.value.socialConfig.disclaimer.needs_endorsement &&
    //         !!state$.value.session.is_disclaimer_endorsed)),
    // ), // Dont make a request if not logged in and no disclaimer is endorsed
    mergeMap(function(action) {
        return from(SocialAPIUtils.getAllSpheres()).pipe(switchMap(function(groups) {
            return [
                fetchGroupsSuccess({
                    groups: groups
                })
            ];
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "fetch_groups"
            }));
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "fetch_groups"
        }));
    }));
}
